import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import "./Styles/orderPage.css";
import Popup from "../Components/Popup";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";
import ReadMoreRoundedIcon from "@mui/icons-material/ReadMoreRounded";
import UpdateRounded from "@mui/icons-material/UpdateRounded";
import CircularProgress from "@mui/material/CircularProgress";
import { AuthLoginInfo } from "../AuthComponents/AuthLogin";
import config from "../config";
import SearchBar from "../Components/SearchBar";
import Pagination from "../Components/Pagination";

function GuestPage() {
  const [guestData, setGuestData] = useState([]);
  const [buttonNewPopup, setButtonNewPopup] = useState(false);
  const [buttonShowPopup, setButtonShowPopup] = useState(false);
  const [selectedGuest, setSelectedGuest] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [newGuestSubmitted, setNewGuestSubmitted] = useState(false);
  const [guestDetails, setGuestDetails] = useState({
    name: "",
    phoneNumber: "",
    zid: "",
    point: 0,
    lastPurchase: "",
  });

  const [filterActive, setFilterActive] = useState(1);
  const [filterGuests, setFilterGuests] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [guestOrders, setGuestOrders] = useState([]);
  const [loadingOrders, setLoadingOrders] = useState(false);

  const handleSearchChange = (newFilteredData) => {
    console.log('newFilteredData', newFilteredData);
    setFilteredData(newFilteredData);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Filter out guests with point = 0
  const filteredByPoint = filteredData.filter(guest => guest.point !== 0);
  const totalGuests = filteredByPoint.length;

  // Sort filtered data based on sortBy state
  const sortedData = [...filteredByPoint].sort((a, b) => {
    if (sortBy === "point-asc") {
      return a.point - b.point;
    } else if (sortBy === "point-desc") {
      return b.point - a.point;
    } else if (sortBy === "lastPurchase-asc") {
      return new Date(a.lastPurchase) - new Date(b.lastPurchase);
    } else if (sortBy === "lastPurchase-desc") {
      return new Date(b.lastPurchase) - new Date(a.lastPurchase);
    }
    return 0;
  });

  const computedGuests = sortedData.slice(
    (currentPage - 1) * itemsPerPage,
    (currentPage - 1) * itemsPerPage + itemsPerPage
  );

  const addNewGuest = () => {
    const token = localStorage.getItem('token');
    axios
      .post(
        `${config.apiEndpoint}/Guest`,
        {
          name: guestDetails.name,
          phoneNumber: guestDetails.phoneNumber,
          zid: guestDetails.zid,
          point: guestDetails.point,
          lastPurchase: guestDetails.lastPurchase,
        },
        { headers: { Authorization: `Bearer ${token}` }, withCredentials: true }
      )
      .then((res) => {
        if (res.status === 201) {
          setGuestDetails({
            name: "",
            phoneNumber: "",
            zid: "",
            point: 0,
            lastPurchase: "",
          });
          console.log("New guest added successfully");
          setButtonNewPopup(false);
          setNewGuestSubmitted(!newGuestSubmitted); // Toggle to trigger useEffect
        }
      })
      .catch((err) => {
        console.error("Error adding new guest:", err);
      });
  };

  const updateGuest = () => {
    const token = localStorage.getItem('token');
    console.log('guestData :', guestDetails);
 
    axios.put(
        `${config.apiEndpoint}/Guest/${guestDetails.id}`,
        {
            id : guestDetails.id,
            name : guestDetails.name,
            phoneNumber : guestDetails.phoneNumber,
            zid : guestDetails.zid,
            point : guestDetails.point,
            lastPurchase : guestDetails.lastPurchase,
        },
        { headers: { Authorization: `Bearer ${token}` }, withCredentials: true }
    )
    .then((res) => {
        if (res.status === 204) {   
            setNewGuestSubmitted(!newGuestSubmitted); // Toggle to trigger useEffect
            setButtonShowPopup(false);
            console.log("Guest updated successfully");
        }
    })
    .catch((err) => {
        console.error("Error updating guest:", err);
    });
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    axios.get(`${config.apiEndpoint}/Guest`, { headers: { Authorization: `Bearer ${token}` }, withCredentials: true })
      .then(res => {
        console.log('guestData', res.data);
        setGuestData(res.data);
        setFilteredData(res.data);
      })
      .catch((err) => {
        console.error("Error fetching guests:", err);
      });
  }, [newGuestSubmitted]);

  return (
    <div className="bodyWrap">
      <div className="contentOrderWrap">
        <div className="leftSide">
          <h1>Guest Manager</h1>
          <Pagination
            total={totalGuests}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onPageChange={(page) => setCurrentPage(page)}
          />
          <div className="orderNavWrap">
            <div className="orderNav">
              <ul>
                <li
                  className={`${filterActive === 1 ? "active" : ""}`}
                  onClick={() => {
                    setFilterGuests("");
                    setFilterActive(1);
                  }}
                >
                  All guests
                </li>
              </ul>
            </div>
            <div className="addOrderWrap">
              <SearchBar
                data={guestData}
                handleSearchChange={handleSearchChange}
                dataType="guest"
                status={filterGuests}
              />
              <select
                className="sortSelect"
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                style={{
                  padding: "8px 12px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                  marginRight: "10px",
                  cursor: "pointer"
                }}
              >
                <option value="">Sắp xếp theo</option>
                <option value="point-asc">Point (Thấp → Cao)</option>
                <option value="point-desc">Point (Cao → Thấp)</option>
                <option value="lastPurchase-asc">Last Purchase (Cũ → Mới)</option>
                <option value="lastPurchase-desc">Last Purchase (Mới → Cũ)</option>
              </select>
              <button
                className="addOrder"
                onClick={() => {
                  setButtonNewPopup(true);
                }}
              >
                <AddCircleOutlineRoundedIcon />
                <span className="addOrderText">Add</span>
              </button>
            </div>
          </div>
          <div className="orderWrap">
            <table>
              <thead>
                <tr>
                  <th>Guest ID</th>
                  <th>Name</th>
                  <th>Phone Number</th>
                  <th>Point</th>
                  <th>Last Purchase</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {computedGuests.map((guest) => {
                    return (
                    <tr key={guest.id}>
                      <td>
                      <font className="maincolor">#</font>
                      {guest.id}
                      </td>
                      <td>{guest.name}</td>
                      <td>{guest.phoneNumber}</td>
                      <td>{guest.point}</td>
                      <td>{guest.lastPurchase}</td>
                      <td className="maincolor">
                      <button
                        className=""
                        style={{ marginRight: "20px" }}
                        onClick={() => {
                        const token = localStorage.getItem('token');
                        axios
                          .delete(`${config.apiEndpoint}/guest/${guest.id}`, {
                          headers: { Authorization: `Bearer ${token}` },
                          withCredentials: true,
                          })
                          .then((res) => {
                          if (res.status === 204) {
                            setNewGuestSubmitted(!newGuestSubmitted); // Toggle to trigger useEffect
                            console.log("Guest removed successfully");
                          }
                          })
                          .catch((err) => {
                          console.error("Error removing guest:", err);
                          });
                        }}
                      >
                        <RemoveRoundedIcon />
                      </button>
                      <button
                        className=""
                        onClick={() => {
                        setButtonShowPopup(true);
                        setSelectedGuest(guestData.indexOf(guest));
                        setGuestDetails(guest);
                        console.log('selectedGuest', selectedGuest);
                        console.log('setGuestDetails', guest);

                        // Fetch guest orders
                        setLoadingOrders(true);
                        setGuestOrders([]);
                        const token = localStorage.getItem('token');
                        axios.get(`${config.apiEndpoint}/Orders/by-guest/${guest.id}`, {
                          headers: { Authorization: `Bearer ${token}` },
                          withCredentials: true,
                        })
                        .then((res) => {
                          setGuestOrders(res.data);
                          setLoadingOrders(false);
                        })
                        .catch((err) => {
                          console.error("Error fetching guest orders:", err);
                          setLoadingOrders(false);
                        });
                        }}
                      >
                        <ReadMoreRoundedIcon />
                      </button>
                      </td>
                    </tr>
                    );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <Popup trigger={buttonNewPopup} setTrigger={setButtonNewPopup}>
        <div className="popupWrap">
          <div className="productSummary">
            <h3 className="productSummaryLeft">Add new Guest</h3>
          </div>
          <div className="addNewOrderWrap">
            <div className="addNewOrderForm">
              <div className="orderDetails">
                <div className="input-group">
                  <input
                    type="text"
                    placeholder="Name"
                    className="orderDetailsInput"
                    value={guestDetails.name}
                    onChange={(e) =>
                      setGuestDetails({
                        ...guestDetails,
                        name: e.target.value,
                      })
                    }
                    required="required"
                  />
                </div>
                <div className="input-group">
                  <input
                    type="text"
                    placeholder="Phone Number"
                    className="orderDetailsInput"
                    value={guestDetails.phoneNumber}
                    onChange={(e) =>
                      setGuestDetails({
                        ...guestDetails,
                        phoneNumber: e.target.value,
                      })
                    }
                    required="required"
                  />
                </div>
                <div className="input-group">
                  <input
                    type="text"
                    placeholder="ZID"
                    className="orderDetailsInput"
                    value={guestDetails.zid}
                    onChange={(e) =>
                      setGuestDetails({
                        ...guestDetails,
                        zid: e.target.value,
                      })
                    }
                    required="required"
                  />
                </div>
                <div className="input-group">
                  <input
                    type="number"
                    placeholder="Point"
                    className="orderDetailsInput"
                    value={guestDetails.point}
                    onChange={(e) =>
                      setGuestDetails({
                        ...guestDetails,
                        point: Number(e.target.value),
                      })
                    }
                    required="required"
                  />
                </div>
                <div className="input-group">
                  <input
                    type="text"
                    placeholder="Last Purchase"
                    className="orderDetailsInput"
                    value={guestDetails.lastPurchase}
                    onChange={(e) =>
                      setGuestDetails({
                        ...guestDetails,
                        lastPurchase: e.target.value,
                      })
                    }
                    required="required"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="submitWrap">
            <div className="submitNewOrder">
              <button
                className="submitNewOrderBtn"
                onClick={() => addNewGuest()}
              >
                <AddCircleOutlineRoundedIcon />
                <span className="addOrderText">Add</span>
              </button>
            </div>
          </div>
        </div>
      </Popup>

      <Popup trigger={buttonShowPopup} setTrigger={setButtonShowPopup}>
      <div className="popupWrap" style={{ minWidth: "700px" }}>
          <div className="productSummary">
            <h3 className="productSummaryLeft">Edit Guest</h3>
          </div>
          <div style={{ display: "flex", gap: "20px" }}>
            <div className="addNewOrderWrap" style={{ flex: 1 }}>
              <div className="addNewOrderForm">
                <div className="orderDetails">
                  {true && (
                    <div className="input-group">
                      <input
                          type="text"
                          placeholder="Name"
                          className="orderDetailsInput"
                          value={guestDetails.name}
                          onChange={(e) =>
                          setGuestDetails({
                              ...guestDetails,
                              name: e.target.value,
                          })
                          }
                          required="required"
                      />
                  </div>
                  )}  

                  {true && (
                    <div className="input-group">
                      <input
                          type="text"
                          placeholder="Phone Number"
                          className="orderDetailsInput"
                          value={guestDetails.phoneNumber}
                          onChange={(e) =>
                          setGuestDetails({
                              ...guestDetails,
                              phoneNumber: e.target.value,
                          })
                          }
                          required="required"
                      />
                  </div>
                  )} 

                  {true && (
                    <div className="input-group">
                      <input
                          type="number"
                          placeholder="Point"
                          className="orderDetailsInput"
                          value={guestDetails.point}
                          onChange={(e) =>
                          setGuestDetails({
                              ...guestDetails,
                              point: Number(e.target.value),
                          })
                          }
                          required="required"
                      />
                  </div>
                  )} 
                </div>
              </div>
            </div>

            <div style={{ flex: 1, maxHeight: "300px", overflowY: "auto" }}>
              <h4 style={{ marginBottom: "10px" }}>Lịch sử đơn hàng</h4>
              {loadingOrders ? (
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100px" }}>
                  <CircularProgress />
                </div>
              ) : guestOrders.length > 0 ? (
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr>
                      <th style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "left" }}>Total</th>
                      <th style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "left" }}>Purchase Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {guestOrders.map((order) => (
                      <tr key={order.id}>
                        <td style={{ padding: "8px", borderBottom: "1px solid #eee" }}>
                          {order.total.toLocaleString()} đ
                        </td>
                        <td style={{ padding: "8px", borderBottom: "1px solid #eee" }}>
                          {new Date(order.purchaseDate).toLocaleString("vi-VN")}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p style={{ color: "#888" }}>Không có đơn hàng nào</p>
              )}
            </div>
          </div>

          <div className="submitWrap">
            <div className="submitNewOrder">
              <button
                className="submitNewOrderBtn"
                onClick={() => {
                    updateGuest();
                }}
              >
                <UpdateRounded />
                <span className="addOrderText">Update</span>
              </button>
            </div>
          </div>
        </div>
      </Popup>
    </div>
  );
}

export default GuestPage;